import { z } from 'zod';
export const MilestoneDatesSchema = z.object({
    '20': z.string(),
    '40': z.string(),
    '60': z.string(),
    '80': z.string(),
    '100': z.string(),
});
export const TrancheSchema = z.object({
    trancheId: z.string().regex(/^[a-z0-9-]+$/),
    clientId: z.string().min(1),
    name: z.string().min(1),
    allocatedTarget: z.number().int().nonnegative(),
    milestoneDates: MilestoneDatesSchema,
    expectedStillToCome: z.number().int().nonnegative().default(0),
    notes: z.string().default(''),
    riskWindowDays: z.number().int().positive().default(14),
    active: z.boolean().default(true),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const UpsertTrancheSchema = TrancheSchema.omit({ createdAt: true, updatedAt: true });
//# sourceMappingURL=tranches.js.map